import {
    get,
    post,
    del,
    put
} from '@/util/request'

//新增
export const InsertdministrativeDivisions = (data) => {
    return post('/api/app/dministrativeDivisions', data);

}
//修改
export const UpdatedministrativeDivisions = (data) => {
    return put('/api/app/dministrativeDivisions', data);
}

//删除by id
export const DeletedministrativeDivisions = (params) => {
    return del(`/api/app/dministrativeDivisions/${params.userId}`);
}

//分页
export const GetdministrativeDivisionsInfo = (data) => {
    return post(`/api/app/dministrativeDivisions/list`, data);
}

export const apiDefRegion = (Type) => {
    let PageQuery = {
        pageindex: 1,
        PageSize: 10000,
        queryModel: {
            level: Type,
        },
        orderbyCloums: "parentCode",
    };
    return post('/api/app/dministrativeDivisions/list', PageQuery);
}




